import * as angular from 'angular';
import {react2angular} from "react2angular";

import {GroupsAdmin} from '../components/groups-admin';

const ngModule = angular.module('dataforvalter.groups-admin', [])
    .component( 'reactGroupsAdmin', react2angular(GroupsAdmin, [], ['server', 'security', '$rootScope']));
const groupsAdminModuleName = ngModule.name;
export default groupsAdminModuleName;
